import { observer } from "mobx-react";
import { TranslateButton, TranslationButtonProps } from "./translate-button";
import pageUrlCoordinationStore from "../layouts/app-layout/page-url-broadcaster/page-url-coordination-store";
import { useNavigate } from "react-router-dom";

const TranslateButtonSPA: React.FC<TranslationButtonProps> = observer((props: TranslationButtonProps) => {
    const navigate = useNavigate();
    const spaPath = props.path;

    return <TranslateButton
        path={pageUrlCoordinationStore.constructLaravelUrl(spaPath)}
        text={props.text}
        onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
            /**
            * Define if the link is not going to be opened in the same tab and do nothing -
            * let a natural browser behaviour happen.
            * The key markers are: not any additional key was pressed, left mouse button was
            * clicked.
            */
            if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button === 1) {
                return;
            }

            e.preventDefault();
            navigate(spaPath);
        }}
    />;
});

export default TranslateButtonSPA;